/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use my phone's edge as the ruler?`)
};

const es_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usar el borde de mi móvil como regla?`)
};

const de_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich die Kante meines Smartphones als Lineal nutzen?`)
};

const nl_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik de rand van mijn telefoon als liniaal gebruiken?`)
};

const fr_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je utiliser le bord de mon téléphone comme règle ?`)
};

const it_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usare il bordo del telefono come righello?`)
};

const pt_br2_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar a borda do celular como régua?`)
};

const pt_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar a extremidade do telemóvel como régua?`)
};

const ja_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォンの端を定規として使えますか?`)
};

const zh_ruler_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我能用手机边缘作为标尺吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_q4", locale)
	if (locale === "en") return en_ruler_faq_q4(inputs)
	if (locale === "es") return es_ruler_faq_q4(inputs)
	if (locale === "de") return de_ruler_faq_q4(inputs)
	if (locale === "nl") return nl_ruler_faq_q4(inputs)
	if (locale === "fr") return fr_ruler_faq_q4(inputs)
	if (locale === "it") return it_ruler_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_q4(inputs)
	if (locale === "pt") return pt_ruler_faq_q4(inputs)
	if (locale === "ja") return ja_ruler_faq_q4(inputs)
	return zh_ruler_faq_q4(inputs)
};